module.exports = __webpack_public_path__ + "static/img/vip_other.78d69a22.png";